import { useTranslation } from 'react-i18next';

interface ExamineeCertificateInfoCardProps {
  email?: string | null;
  additionalEmail?: string | null;
}

function ExamineeCertificateInfoCard(props: Readonly<ExamineeCertificateInfoCardProps>) {
  const { email, additionalEmail } = props;

  const { t } = useTranslation();

  const shouldDisplayEmailInfo = !!email || !!additionalEmail;

  return (
    <>
      {shouldDisplayEmailInfo ? (
        <div className='flex flex-col gap-3'>
          <p>{t('examResult.emailDescription')}</p>
          {email ? (
            <div className='border-border-divider flex justify-between rounded-lg border p-4'>
              <p className='font-semibold'>{email}</p>
              <span className='text-success-700 bg-success-100 border-success-500 rounded-[28px] border px-2.5 text-sm'>
                {t('profileConfirmationForm.form.registerEmail')}
              </span>
            </div>
          ) : null}

          {additionalEmail ? (
            <div className='border-border-divider flex justify-between rounded-lg border p-4'>
              <p className='font-semibold'>{additionalEmail}</p>
              <span className='rounded-[28px] border border-gray-500 bg-gray-100 px-2.5 text-sm text-gray-700'>
                {t('examResult.additionalEmail')}
              </span>
            </div>
          ) : null}
        </div>
      ) : null}
      <div className='rounded-lg bg-gray-50 px-4 py-3'>
        <p className='text-sm'>
          {t('examResult.certificateSendingDescription')}
          <span className='font-semibold'> TSIExamreport_noreply@set.or.th</span>
        </p>
      </div>
    </>
  );
}

export default ExamineeCertificateInfoCard;
